{
  "common": {
    "first_name": "First Name",
    "last_name": "Last Name",
    "full_name": "Full name",
    "name": "Name",
    "email_address": "E-mail address",
    "your_email": "Your e-mail",
    "telephone": "Telephone",
    "tel": "Tel",
    "avatar": "Avatar",
    "username": "Username",
    "roll": "Roll | Roles",
    "action": "Action | Actions",
    "page": "Page | Pages",
    "section": "Section | Sections",
    "filter": "Filter | Filters",
    "search": "Search",
    "greeting": "Hi there",
    "download": "Download | Downloads",
    "file": "file | files",
    "powered_by": "Powered by",
    "sort_by": "Sort by",
    "recently_modified": "recently modified",
    "edit": "Edit",
    "make_private": "Make private",
    "delete": "Delete",
    "set_destination": "Set Destination",
    "currently_in": "Currently in",
    "admin": "Administrator",
    "user": "user | users",
    "functionality": "functionality",
    "password": "Password",
    "new_password": "New password",
    "repeat_new_password": "Repeat new password",
    "month_short": "mo",
    "cropping": "Cropping",
    "recognition": "Recognition",
    "confirm": "Confirm",
    "min_ago": "min ago | mins ago",
    "hour_ago": "hour ago | hours ago",
    "yesterday": "yesterday",
    "load_more": "Load more",
    "last_week": "Last week",
    "last_month": "Last month",
    "last_year": "Last year",
    "you": "you",
    "create": "create",
    "created": "created",
    "deleted": "deleted",
    "in": "in",
    "submit": "Submit",
    "update": "Update",
    "updating": "Updating",
    "upload": "Upload",
    "uploading": "Uploading",
    "more": "More",
    "not_again": " Don't show these messages again",
    "remove": "Remove",
    "done": "Done",
    "something_went_wrong": "Something went wrong.",
    "of": "of",
    "amount": "Amount",
    "status": "Status",
    "max": "MAX",
    "address": "Address",
    "country": "Country",
    "none": "None",
    "cancel": "Cancel",
    "updated": "Updated",
    "request_access": "Request Access",
    "processing": "Processing",
    "remaining": "remaining",
    "tag": "Tag | Tags",
    "add_tag": "Add Tag",
    "your_tag": "Your tag",
    "show_tags": "Show tags",
    "hide_tags": "Hide tags",
    "update_tag": "Update tag",
    "no_tags": "No tags yet",
    "add": "Add",
    "copy_link": "Copy link",
    "description": "Description",
    "color": "Color",
    "try_again_later": "Try again later.",
    "folder": "folder | folders",
    "email_comma": "E-mails (comma separated)",
    "email_error": "E-mails please, no gibberish... | E-mail please, no gibberish...",
    "copy": "Copy",
    "copied": "Copied",
    "logout": "Logout",
    "move_to": "Move to",
    "contact_details": "Contact Details",
    "company_information": "Company Information",
    "company": "Company",
    "back": "Back",
    "request": "Request",
    "next": "Next",
    "close": "Close",
    "rename": "Rename",
    "move": "Move",
    "who_is_this": "Who is this?",
    "size": "Size",
    "show_all": "Show all",
    "hide_all": "Hide all",
    "person": "Person | Persons",
    "downloading": "Downloading",
    "type": "Type",
    "modified": "Date",
    "width": "Width",
    "height": "Height",
    "reset_default": "Reset default",
    "invalid_email": "Invalid email.",
    "help_center": "Help Center",
    "item": "item | items",
    "storage": "Storage",
    "save": "Save",
    "premission": "Permission | Permissions",
    "expand_all": "Expand all",
    "collapse_all": "Expand all",
    "replace": "Replace",
    "notify": "Notify",
    "add_users_or_emails": "Add existing users or email address",
    "view_all_recipients": "View all recipients {recipients}",
    "paste": "Paste",
    "all_pasted": "All items are pasted",
    "nothing_to_paste": "Nothing to paste",
    "add_exteral_link": "Add exteral link",
    "exteral_link_name": "External link name",
    "open": "Open",
    "view_more": "View more",
    "Edit_image": "Edit image",
    "extension": "Extension | Extensions",
    "day": "day | days",
    "selected": "selected",
    "download_ready": "Download ready",
    "upload_ready": "Upload ready",
    "upload_error": "Upload failed",
    "upload_canceled": "Upload canceled",
    "details": "Details",
    "unknown": "Unknown",
    "transform": "Transform | Transforms",
    "info": "Info",
    "custom": "Custom",
    "square": "Square",
    "pending": "Pending",
    "large": "Large",
    "medium": "Medium",
    "view": "View"
  },
  "main_menu": {
    "my_space": "My Space"
  },
  "settings_menu": {
    "manage_user": "Manage user | Manage users",
    "terms_of_service": "Terms of Service",
    "account": "Account",
    "branding": "Branding",
    "plan_and_billing": "Plan & Billing",
    "help_center": "Help Center",
    "privacy_and_legal": "Privacy & Legal",
    "about_us": "About us",
    "pricing": "Pricing",
    "back_to_spaces": "Back to Spaces"
  },
  "transfer": {
    "transfer": "Transfer",
    "sent_link": "sent you a transfer link.",
    "download_below": "Download below when ready.",
    "link_timeout": "Your link will be here for {count} more days.",
    "processing": "Unfortunately, we are still processing the transfer...",
    "processingTime": "Processing of transfers can take up to {hours} hours.",
    "transfer_complete": "Transfer complete",
    "sent": "Sent",
    "send": "Send",
    "transfer_collection": "Transfer collection",
    "on_its_way": "It's on its way to",
    "transfer_files": "Transfer Files",
    "transfer_to": "Transfer to",
    "get_download_link": "Get download link",
    "send_with_email": "Send with e-mail",
    "title": "Share everything.",
    "desc": " Lorem ipsum dolor sit amet, consectetur adipiscing elit praesent facilisis,",
    "quick_transfer": "Quick Transfer",
    "transfer_from_spaces": "Transfer From Spaces",
    "here_download": "Here's your download link",
    "or_get_download_link": "Or get a download link",
    "or_send_email": "Or send with e-mail",
    "ready_to_go": " All ready to go, we just need to know where you're sending the files.",
    "access_files": " All ready to go, just use the link below to access your files for the next {days} days.",
    "sent_to": "Sent to",
    "getting_you_files": "Getting your files"
  },
  "manage_users": {
    "all_users": "All users",
    "filter_message": "No users were found for this role, try filtering again.",
    "add_roll": "Add new role",
    "role_name": "Role name",
    "view_user": "View user | View users",
    "add_new_user": "Add new user | Add new users",
    "add_user": "Add User | Add Users",
    "add_user_desc": "Invite a brand new users",
    "edit_user": "Edit user | Edit users",
    "user_role": "User role",
    "reset_Password": "Reset password",
    "resend_invitation_email": "Re-send invitation email",
    "user_updated": "User was successfully updated.",
    "password_reset_send": "Password reset link successfully send.",
    "user_invite_resend": "User invitation successfully re-send.",
    "view_members": "View members",
    "delete_member": "Delete member",
    "add_member": "Add member",
    "delete_user_from_role": "Are you sure to delete this user from this role?",
    "delete_user_from_role_desc": "He/she will be made a basic user.",
    "invite_role": "Invite a user to join this role.",
    "delete_user": "Are you sure to delete this user?",
    "delete_user_desc": "He/she will be deleted from your herd.",
    "user_deleted": "User was successfully deleted.",
    "select_role": "Select Role",
    "user_exists": "Uh-oh! There's already someone with that name in your herd. Please add a different username.",
    "user_added": "The user was successfully added to your herd.",
    "role_updated": "Role successfully updated.",
    "added_Role": "The {name} roll has been added.",
    "delete_Role": "Delete Role",
    "delete_Role_sure": "Are you sure to delete this role?",
    "delete_Role_sure_desc": "This role will be deleted",
    "role_deleted": "Role was successfully deleted.",
    "manage_herd": "Manage your herd",
    "add_roll_desc": "Choose a name for a new role and start customizing."
  },
  "terms_of_service": {
    "new_page": "New Page",
    "add_page": "Add Page",
    "update_page": "Update Page",
    "privacy_cookies": "Privacy & Cookies"
  },
  "spaces": {
    "space": "Space | Spaces",
    "empty_title": "This space is empty.",
    "empty_text": "An empty space is a bit boring, isn't it. Start filling it with your documents, images, templates, prank, etc. Put your files in folders for more structure.",
    "Go_to_space": "Go to Space | Go to Spaces",
    "hex_code": "Hex code",
    "use_hex": "Or use HEX code",
    "use_color": "Or pick a color",
    "make_private": "Make space private",
    "space_created": "Space created",
    "edit_space": "Edit space",
    "delete_space": "Delete space",
    "create_space": "Create space | Create spaces",
    "space_exists": "A Space with this name already exists.",
    "no_spaces": "No Spaces yet",
    "space_added": "Space succesfully added!",
    "space_desc": "Space description",
    "create_space_info": "Push the button and create <br/> as many spaces as you want to.",
    "space_updated": "Space succesfully updated!",
    "space_name": "Space name",
    "access_to": "Access to view following spaces",
    "add_space": "Add space"
  },
  "files": {
    "empty_myspace_title": "Add your personal files here.",
    "empty_myspace_text": "This is your own private universe. Fill this space with files and folders for your eyes only.",
    "empty_folder_title": "Drag and drop here files",
    "empty_folder_text": "Upload everything from spreadsheets to selfies. Just keep it under",
    "new_folder": "New Folder",
    "new_folder_placeholder": "Folder name",
    "upload_file": "Upload file | Upload files",
    "format": "The format is incorrect.",
    "destination": "Destination",
    "choose_destination": "Choose Destination",
    "choose_files": "Choose Files",
    "add_files": "Add files",
    "add_folder": "Add folder",
    "files_up_to": "Files up to",
    "no_folders": "No Folders yet",
    "rename_file": "Rename file",
    "rename_folder": "Rename folder",
    "delete_file": "Delete file",
    "delete_folder": "Delete folder",
    "move_file": "Move file",
    "replace_file": "Replace file",
    "move_folder": "Move folder",
    "create_folder": "Create folder",
    "date_added": "Date added",
    "dimensions": "Dimensions",
    "length": "Length",
    "location": "Location",
    "faces": "Faces",
    "show_faces": "Show faces",
    "hide_faces": "Hide faces",
    "update_face": "Update face",
    "add_face": "Add face",
    "no_face": "No faces yet",
    "low_res": "low res",
    "crop_image": "Crop Image",
    "remove_crop": "Remove crop",
    "crop_dimensions": "Crop Dimensions",
    "file_to_replace": "File to replace",
    "make_public": "Make public",
    "make_private": "Make Private",
    "move_selection": "Move Selection",
    "copy_selection": "Copy Selection",
    "delete_selection": "Delete Selection",
    "copy_file": "Copy File",
    "copy_folder": "Copy Folder",
    "use_on_homescreen": "Use on Home Screen",
    "added_to_homescreen": "added to Home Screen",
    "folder_exists": "Wow! That folder already exists! Please be a bit more creative...",
    "new_name": "New name",
    "ratio": "aspect ratio",
    "basic_details": "Basic details",
    "image_details": "Image details"
  },
  "upload": {
    "upload_home": "Upload everything from spreadsheets to selfies. Just keep it under",
    "upload_more": "Upload more files",
    "upload_limit_reached": "Your storage limit is reached! No more uploads allowed!",
    "upload_count_limit": "Come now, one hundred files is plenty.",
    "upload_size_limit": "More than {size}? Can't do that without alerting the CIA.",
    "drop_upload": "Drop here to upload",
    "upload_dubble_file": "Uh-oh. Looks like you're trying to upload the same file twice.",
    "request_review": "Your request is send for review",
    "request_review_desc": "You will receive an e-mail once it's accepted",
    "user_unknown": "This user is unkown to us.",
    "email_unknown": "This email is unkown to us."
  },
  "search": {
    "search_empty_title": "Oops. No results for your search.",
    "search_empty_desc": "Sorry, but we couldn't find what you're looking for. Make sure you check the spelling of your search.",
    "result": "result | results",
    "select_type": "Select a type",
    "select_extension": "Select an extension"
  },
  "login": {
    "login": "Login",
    "workspace_sign_in": "Sign into your workspace",
    "back_to_credentials": "Back to Credentials",
    "credentials_match_error": "Your credentials do not match our records.",
    "forgot_username": "Forgot Username?",
    "link_underway": "The link is on it's way!",
    "magic_link": "Send magic link",
    "back_to_login": "Back to login",
    "send_usernames": "We'll need your email address to send you your usernames.",
    "request_send": "Your request is send. Wait for approval now.",
    "field_of_activity": "Field of Activity",
    "architecture": "Architecture",
    "digital_it": "Digital & IT",
    "hospitality": "Hospitality",
    "interior_design": "Interior design",
    "marketing": "Marketing",
    "press": "Press",
    "retail": "Retail",
    "other": "Other",
    "is_required": "is required",
    "user_forgot": "We'll need your email to send you the magic link to secure your account",
    "password_forgot": "We'll need your username to send you the magic link to secure your account",
    "forgot_password": "Forgot your password?"
  },
  "plan": {
    "title": "Not every herd needs the same treatment.",
    "sub_title": "Choose the formula that suits you best based on memory space, number of users and other features.",
    "storage_space": "storage space",
    "default_user_roles": "default user roles",
    "quick_tranfer_up_to": "Quick tranfer up to",
    "tool_presets": "Tool & Presets",
    "face_and_object": "Face & Object",
    "protected_spaces": "protected Spaces",
    "current_plan": "Current Plan",
    "choose_this_plan": "Choose this plan",
    "user_roll": "user roll | user roles",
    "custom_roles": "Custom roles",
    "feedback": "Not satisfied? We would love to hear your feedback",
    "continue_to_payment": "Continue to payment",
    "change_plan": "Change Plan",
    "upgrade_to_paid_plan": "Upgrade to paid plan",
    "plan": "Plan"
  },
  "notifications": {
    "title": "Notifications"
  },
  "no_page": {
    "title": "Uh oh, looks like we lost you. \n Let's get back on track.",
    "back_to_home": "Back to home"
  },
  "collection": {
    "collection": "Collection | Collections",
    "collect": "Collect",
    "collected": "Collected",
    "new_collections": "New Collection",
    "create_collections": "Create Collection",
    "create_collections_title": "Create your collections.",
    "create_collections_text": "With collections, you can bundle multiple files. Only you can create, view and transfer these collections.",
    "download_collection": "Download collection",
    "transfer_collection": "Transfer collection",
    "rename_collection": "Rename collection",
    "delete_collection": "Delete collection",
    "add_collection": "Add collection",
    "empty_title": "Start collecting here.",
    "empty_text": "Fill your collection with files from various spaces.  You can choose to download or transfer your collection whenever you want.",
    "add_first_collection": "Add your first collection",
    "add_first_collection_desc": "Click 'add collection' to create your first collection of files.",
    "collect_for_download": "Collect for Download",
    "delete_file": "Are you sure you want to delete the selected file {addS} from this collection?",
    "delete_this_collection": "Are you sure you want to delete this collection?",
    "delete_items": "Are you sure you want to delete the selected item{addS}?",
    "no_collections_yet": "No Collections yet",
    "files_collected": "Files Collected",
    "choose_collection": "Choose collection",
    "existing_collection": "Existing Collection",
    "no_folders_error": "You can't collect folders, your selected files will be added",
    "name_of_collection": "Name of collection",
    "collection_already_exists": "That collection already exists... Be more creative.",
    "collection_already_exists_file": "You are trying to collect a folder that already exists in this collection",
    "collection_already_exists_folder": "You are trying to collect a file that already exists in this collection",
    "collection_added": "Collection succesfully added!",
    "collection_name": "Collection name"
  },
  "branding": {
    "naming": "Naming",
    "display_name": "Display name",
    "display_name_desc": "The name used in all outgoing notifications \n (E-mails,...)",
    "analytics": "Analytics",
    "analytics_desc": "A Google Analytics ID to track users on your Sheprd",
    "analytics_error": "The analytics id is incorrect.",
    "automatic_tags": "Automatic Tags",
    "automatic_tag_desc": " Turn this feature on so each image you upload gets automated tags using AI. These tags can help you find the right image later on as they will show up in the search results. You can also add tags manually for even more control.",
    "branding_and_logo": "Branding & Logo",
    "home_screen": "Home Screen",
    "home_screen_desc": "Upload a background image to represent your brand on the homepage. <br/> <span>Preferably: png, jpeg, jpg or mp4 with {dimensions} dimensions</span>",
    "home_logo": "Home Logo",
    "home_logo_desc": "Upload a logo on top of your Home Screen <br/> <span>Preferably: PNG with transparent background and {dimensions} dimensions</span>",
    "nav_logo": "Navigation Logo",
    "nav_logo_desc": " Upload a logo in the navigation bar <br/> <span>Preferably: PNG with transparent background and {dimensions} dimensions</span>",
    "social_accounts": "Social Accounts",
    "brand_color": "Brand color",
    "brand_color_desc": "Make Sheprd your own with your brand colors. <br/> recommended to use a very dark color",
    "brand_color_not_a_color": "Invalid color",
    "brand_color_to_light": "This color is to light. Please use a darker color"
  },
  "billing": {
    "billing": "Billing",
    "plan_and_billing_info": "Plan & Billing Information",
    "trail_expired": "Trial expired",
    "service_period_of": "Service period of",
    "more_space_or_functionalities": "More space or functionalities?",
    "contact_us": "Contact us for more solutions",
    "next_payment": "Next payment scheduled for",
    "processing_fee": " We are obliged to charge a processing fee. Which will be subtracted from your next payment",
    "billing_history": "Billing History",
    "invoice_date": "Invoice Date",
    "service_period": "Service Period",
    "last_day_trial": "Last day of trial"
  },
  "account": {
    "contact_details": "Your contact details",
    "name_required": "Your name is required",
    "email_info": " You will receive important notifications at this email, and your client will see this email where applicable",
    "avatar_info": " Show yourself, this will come in handy for the administrator to notice you.",
    "prefered_size": "PREFERRED SIZE",
    "company_name": "Company name",
    "field_of_activity": "Field of Activity",
    "username_unique": " Your username must be unique",
    "password_placeholder": "Enter your current password",
    "password_info": "Leave empty to keep default.",
    "password_incorrect": "Your password is incorrect",
    "new_password_info": "Enter your new password",
    "repeat_new_password_info": "Repeat your new password",
    "repeat_new_password_error": "These passwords do not match",
    "personal_settings": "Personal settings",
    "continues_download_notification": "Continues download notification",
    "download_notification_desc": " Get an email every time a transfer gets downloaded. When swiched of the notification will only be sent once.",
    "download_notification": "Download notification",
    "email_notification": "Receive an email every time a user downloads something.",
    "delete_account": "Delete your account"
  },
  "welcome_root_folder": {
    "are_you_sure": "Woah woah!<br />Are we sure about this?",
    "empty_spaces_title": "Excited? Start you first space now.",
    "empty_spaces_desc": "A space offers you structure and an overview. <br /> Start adding folders and organize your files the way you want to.",
    "empty_spaces_public": "Uh oh! Seems like there are no<br />public spaces to show you."
  },
  "error": {
    "private_folder": "Could not set private folder",
    "rename_folder": "Could not rename folder",
    "rename_file": "Could not rename file",
    "rename_collection": "Could not rename collection",
    "delete_file": "Could not delete file",
    "delete_folder": "Could not delete folder",
    "delete_collection": "Could not delete collection",
    "collect_selected": "Could not collect selected",
    "dowload": "Could not download selected",
    "dowload_file": "Could not download file",
    "add_folder": "Could not download file",
    "dowload_collection": "Could not download collection",
    "add_collection": "Could not add collection",
    "account_update": "Could not update account",
    "find_collection": "Could not find collection",
    "get_files": "Could not get files",
    "collect_file": "Could not get files",
    "collect_paste": "Could not paste items",
    "find_notifications": "Could not find any notifications",
    "user_already_present": "Silver medal in sprint! Another admin was first in accepting this account.",
    "back_to_users": "Back to users",
    "invite_accepted": "Invite already accepted"
  },
  "editor": {
    "flip_horizontal": "Flip horizontal",
    "flip_vertical": "Flip vertical",
    "rotate_left": "Rotate left",
    "rotate_right": "Rotate right",
    "brightness": "Brightness",
    "contrast": "Contrast",
    "hue": "Hue",
    "saturation": "Saturation",
    "blur": "Blur",
    "reset_changes": "Reset changes",
    "save_copy": "Save copy"
  },
  "file_details": {
    "created_at": "Created at",
    "size": "Size",
    "pages": "Pages",
    "dimensions": "Dimensions",
    "usercomment": "User comment",
    "image width": "Image width",
    "image height": "Image height",
    "bit depth": "Bit depth",
    "color type": "Color type",
    "compression": "Compression",
    "filter": "Filter",
    "interlace": "Interlace",
    "aperturevalue": "Aperture",
    "bits per sample": "Bits per sample",
    "color components": "Color components",
    "color space": "Color space",
    "connection space": "Connection space",
    "contrast": "Contrast",
    "copyright": "Copyright",
    "createdate": "Creation date",
    "creatortool": "Creator tool",
    "customrendered": "Custom rendered",
    "datecreated": "Date created",
    "datetimedigitized": "Date digitized",
    "datetimeoriginal": "Date original",
    "device manufacturer": "Device manufacturer",
    "device model number": "Device model number",
    "exif ifd pointer": "Exif ifd pointer",
    "exifversion": "Exif version",
    "exposurebiasvalue": "Exposure bias",
    "exposuremode": "Exposure mode",
    "exposureprogram": "Exposure program",
    "exposuretime": "Exposure time",
    "fnumber": "Fnumber",
    "filesource": "File source",
    "flash": "Flash",
    "focallength": "Focal length",
    "focallengthin35mmfilm": "Focal length in 35mm film",
    "icc copyright": "Icc copyright",
    "icc description": "Icc description",
    "icc device manufacturer for display": "Icc device manufacturer for display",
    "icc device model description": "Icc device model description",
    "icc profile date": "Icc profile date",
    "icc signature": "Icc signature",
    "icc viewing conditions description": "Icc viewing conditions description",
    "isospeedratings": "Iso speed ratings",
    "jfif thumbnail height": "Jfif thumbnail height",
    "jfif thumbnail width": "Jfif thumbnail width",
    "jfif version": "Jfif version",
    "lens": "Lens",
    "lensinfo": "Lens info",
    "lensmake": "Lens make",
    "lensserialnumber": "Lens serial number",
    "lensspecification": "Lens specification",
    "lightsource": "Lightsource",
    "make": "Make",
    "maxaperturevalue": "Max aperture",
    "meteringmode": "Metering mode",
    "model": "Model",
    "preferred cmm type": "Preferred cmm type",
    "primary platform": "Primary platform",
    "profile creator": "Profile creator",
    "profile/device class": "Profile/device class",
    "rendering intent": "Rendering intent",
    "resolution unit": "Resolution unit",
    "resolutionunit": "Resolution unit",
    "saturation": "Saturation",
    "scenecapturetype": "Scene capture type",
    "sensingmethod": "Sensing method",
    "sensitivitytype": "Sensitivity type",
    "serialnumber": "Serial number",
    "sharpness": "Sharpness",
    "shutterspeedvalue": "Shutter speed",
    "software": "Software",
    "standardoutputsensitivity": "Standard output sensitivity",
    "subsampling": "Subsampling",
    "technology": "Technology",
    "whitebalance": "White balance",
    "xresolution": "X resolution",
    "yresolution": "Y resolution",
    "about": "About"
  },
  "tooltip": {
    "space": "space",
    "folders": "",
    "files": "",
    "tags": "",
    "faces": "",
    "notifications": "",
    "copy_paste": "",
    "admin": "",
    "users": "",
    "roles": "",
    "branding": "",
    "collect": "",
    "transfer": "",
    "quick_transfer": "",
    "my_space": ""
  }
}
